import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Catalog from './pages/Catalog';
import NotFoundPage from './pages/NotFoundPage';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminProductForm from './pages/AdminProductForm';
import AdminBulkPrice from './pages/AdminBulkPrice';
import AdminUsers from './pages/AdminUsers';
import AdminUserForm from './pages/AdminUserForm';
import AdminPaymentMethods from './pages/AdminPaymentMethods';
import AdminShipping from './pages/AdminShipping';
import AdminPromoConfig from './pages/AdminPromoConfig';
import AdminDiscounts from './pages/AdminDiscounts';
import AdminLogin from './pages/AdminLogin';
import AdminInteractions from './pages/AdminInteractions';
import AdminSettings from './pages/AdminSettings';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check authentication status on mount
  useEffect(() => {
    const authStatus = sessionStorage.getItem('adminAuthenticated');
    setIsAuthenticated(authStatus === 'true');
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuthenticated');
    setIsAuthenticated(false);
  };

  // Protected Route wrapper
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/admin/login" replace />;
    }
    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />

        {/* Catalog - only accessible via essenNumber */}
        <Route path="/:essenNumber" element={<Catalog />} />

        {/* Admin Login Route */}
        <Route
          path="/admin/login"
          element={
            isAuthenticated ?
              <Navigate to="/admin" replace /> :
              <AdminLogin onLogin={handleLogin} />
          }
        />

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout onLogout={handleLogout} />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="new" element={<AdminProductForm />} />
          <Route path="edit/:id" element={<AdminProductForm />} />
          <Route path="bulk-price" element={<AdminBulkPrice />} />
          <Route path="payment-methods" element={<AdminPaymentMethods />} />
          <Route path="shipping" element={<AdminShipping />} />
          <Route path="promo-config" element={<AdminPromoConfig />} />
          <Route path="discounts" element={<AdminDiscounts />} />
          <Route path="platformUsers" element={<AdminUsers />} />
          <Route path="platformUsers/new" element={<AdminUserForm />} />
          <Route path="platformUsers/edit/:id" element={<AdminUserForm />} />
          <Route path="interactions" element={<AdminInteractions />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* Catch-all Route for 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;